import { DOCUMENT } from "@angular/common";
import { AfterViewInit, Directive, ElementRef, Inject, Input, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";

@Directive({
    selector: "[kno2AutoFocus]",
    standalone: false
})
export class AutoFocusDirective implements AfterViewInit, OnDestroy {
    private shouldFocus = true;

    @Input() public set kno2AutoFocus(shouldFocus: boolean) {
        this.shouldFocus = typeof shouldFocus === "boolean" ? shouldFocus : true;
        this.focusElement(this.shouldFocus);
    }

    public subscriptions: Array<Subscription> = [];

    constructor(
        private host: ElementRef,
        @Inject(DOCUMENT) private document: Document
    ) {}

    public ngAfterViewInit(): void {
        if (this.host.nativeElement !== this.document.activeElement && this.shouldFocus) this.focusElement(true);
    }

    public ngOnDestroy(): void {
        this.subscriptions.forEach((x) => x.unsubscribe());
    }

    private focusElement(focus: boolean): void {
        if (!focus) return this.host.nativeElement.blur();

        if (this.host.nativeElement?.children[0]?.type === "button") {
            this.host.nativeElement?.children[0].focus();
        } else {
            this.host.nativeElement.focus();
        }
    }
}
